import { ICON_NAMES } from "@/cms/icons";

/** Blank starting value for a field kind — used when a new list item is
 * added and there's no existing data to seed it with. */
export function defaultValueForField(field) {
  switch (field.kind) {
    case "icon":
      return ICON_NAMES[0];
    case "select":
      return field.options?.[0] ?? "";
    case "list":
      return [];
    default:
      return "";
  }
}

export function defaultItemForFields(itemFields) {
  return Object.fromEntries(
    itemFields.map((f) => [f.key, defaultValueForField(f)]),
  );
}
